import { Navigate } from "react-router-dom";
import { useAuth } from "@clerk/react";
import Stack from "@mui/joy/Stack";
import LottieLoader from "@/components/Loader/LottieLoader";

interface Props {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: Props) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <Stack alignItems={"center"} justifyContent={"center"} sx={{ width: "100%", height: "100%" }}>
        <LottieLoader />
      </Stack>
    );
  }

  return isSignedIn ? (
    children
  ) : (
    <Navigate to={"/auth/login"} replace state={{ from: window.location.pathname + window.location.search }} />
  );
};
export default ProtectedRoute;
